import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Nosotros from "@/pages/Nosotros";
import Servicios from "@/pages/Servicios";
import Especialistas from "@/pages/Especialistas";
import Colecciones from "@/pages/Colecciones";
import Enfoques from "@/pages/Enfoques";
import Forense from "@/pages/Forense";
import Contacto from "@/pages/Contacto";
import Cuestionario from "@/pages/Cuestionario";
import AvisoPrivacidad from "@/pages/AvisoPrivacidad";
import Confidencialidad from "@/pages/Confidencialidad";
import AgendaRedirect from "@/pages/AgendaRedirect";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/especialistas" element={<Especialistas />} />
            <Route path="/colecciones" element={<Colecciones />} />
            <Route path="/enfoques" element={<Enfoques />} />
            <Route path="/psicologia-forense" element={<Forense />} />
            <Route path="/cuestionario" element={<Cuestionario />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
            <Route path="/politica-de-confidencialidad" element={<Confidencialidad />} />
            <Route path="/agenda" element={<AgendaRedirect />} />
          </Routes>
        </Layout>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "#4a1521",
              color: "#f5efe6",
              border: "1px solid rgba(184,151,90,0.4)",
              fontFamily: "Cormorant Garamond, serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
